// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LdEt","left":"styles_left__SjUhW"};